// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Overlay */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    padding: 20px;
    box-sizing: border-box;
}

/* Modal Container */
.modal {
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    width: 100%;
    position: relative;
    animation: modalFadeIn 0.2s ease-out;
}

/* Modal Animation */
@keyframes modalFadeIn {
    from {
        opacity: 0;
        transform: scale(0.95) translateY(-10px);
    }
    to {
        opacity: 1;
        transform: scale(1) translateY(0);
    }
}

/* Modal Sizes */
.modal--small {
    max-width: 400px;
}

.modal--medium {
    max-width: 600px;
}

.modal--large {
    max-width: 800px;
}

.modal--fullscreen {
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    border-radius: 0;
    margin: 0;
}

/* Modal Header */
.modal__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #eee;
    flex-shrink: 0;
}

.modal__title, div.page section h2.modal__title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #1f2937;
    line-height: 1.5;
    border: none;
    padding: 0;
}

.modal__close-button {
    background: none;
    border: none;
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
    color: #6b7280;
    padding: 4px;
    margin: -4px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: color 0.15s ease, background-color 0.15s ease;
}

.modal__close-button:hover {
    color: #374151;
    background-color: #f3f4f6;
}

.modal__close-button:focus {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
}

/* Modal Content */
.modal__content {
    padding: 24px;
    overflow-y: auto;
    flex: 1;
    min-height: 0; /* Allow content to shrink */
}

/* Modal Footer */
.modal__footer {
    padding: 16px 24px;
    border-top: 1px solid #eee;
    background-color: #f9fafb;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    flex-shrink: 0;
}

/* Mobile Styles */
@media (max-width: 768px) {
    .modal-overlay {
        padding: 10px;
        align-items: flex-end;
    }

    .modal {
        max-height: 95vh;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        animation: modalSlideUp 0.3s ease-out;
    }

    @keyframes modalSlideUp {
        from {
            opacity: 0;
            transform: translateY(100%);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .modal--fullscreen {
        height: 100vh;
        max-height: 100vh;
        border-radius: 0;
    }

    .modal__header {
        padding: 16px 20px;
    }

    .modal__title {
        font-size: 1.125rem;
    }

    .modal__content {
        padding: 20px;
    }

    .modal__footer {
        padding: 16px 20px;
    }

    /* Make all modals nearly fullscreen on small devices */
    .modal--small,
    .modal--medium,
    .modal--large {
        max-width: 100%;
        width: 100%;
    }
}

/* Extra small mobile devices */
@media (max-width: 480px) {
    .modal-overlay {
        padding: 0;
    }

    .modal {
        height: 100vh;
        max-height: 100vh;
        border-radius: 0;
        animation: modalSlideUp 0.3s ease-out;
    }

    .modal__header {
        padding: 12px 16px;
        position: sticky;
        top: 0;
        background: white;
        z-index: 1;
    }

    .modal__content {
        padding: 16px;
    }

    .modal__footer {
        padding: 12px 16px;
        position: sticky;
        bottom: 0;
        background: #f9fafb;
        z-index: 1;
    }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
    .modal {
        border: 2px solid #000;
    }

    .modal__header,
    .modal__footer {
        border-color: #000;
    }

    .modal__close-button:hover {
        background-color: #000;
        color: #fff;
    }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
    .modal {
        animation: none;
    }

    .modal__close-button {
        transition: none;
    }
}

/* Focus trap styles */
.modal *:focus {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
}

/* Scrollbar styling for modal content */
.modal__content::-webkit-scrollbar {
    width: 8px;
}

.modal__content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.modal__content::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.modal__content::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Dark mode */
[data-theme="dark"] .modal-overlay {
    background: rgba(0, 0, 0, 0.7);
}

[data-theme="dark"] .modal {
    background: #1c2620;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.4), 0 1px 3px rgba(0, 0, 0, 0.3);
}

[data-theme="dark"] .modal__header {
    border-bottom-color: #2c3a33;
}

[data-theme="dark"] .modal__title,
[data-theme="dark"] div.page section h2.modal__title {
    color: #e3ece6;
}

[data-theme="dark"] .modal__close-button {
    color: #9fb0a6;
}

[data-theme="dark"] .modal__close-button:hover {
    color: #e3ece6;
    background-color: #222f28;
}

[data-theme="dark"] .modal__footer {
    border-top-color: #2c3a33;
    background-color: #222f28;
}

[data-theme="dark"] .modal__content::-webkit-scrollbar-track {
    background: #1c2620;
}

[data-theme="dark"] .modal__content::-webkit-scrollbar-thumb {
    background: #3a463e;
}

[data-theme="dark"] .modal__content::-webkit-scrollbar-thumb:hover {
    background: #4a5850;
}

@media (max-width: 480px) {
    [data-theme="dark"] .modal__header {
        background: #1c2620;
    }

    [data-theme="dark"] .modal__footer {
        background: #222f28;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA,oBAAoB;AACpB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,uEAAuE;IACvE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA,oBAAoB;AACpB;IACI;QACI,UAAU;QACV,wCAAwC;IAC5C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,gBAAgB;IAChB,OAAO;IACP,aAAa,EAAE,4BAA4B;AAC/C;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;IACzB,8BAA8B;IAC9B,+BAA+B;IAC/B,cAAc;AAClB;;AAEA,kBAAkB;AAClB;IACI;QACI,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,gBAAgB;QAChB,4BAA4B;QAC5B,6BAA6B;QAC7B,qCAAqC;IACzC;;IAEA;QACI;YACI,UAAU;YACV,2BAA2B;QAC/B;QACA;YACI,UAAU;YACV,wBAAwB;QAC5B;IACJ;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA,uDAAuD;IACvD;;;QAGI,eAAe;QACf,WAAW;IACf;AACJ;;AAEA,+BAA+B;AAC/B;IACI;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,gBAAgB;QAChB,qCAAqC;IACzC;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,MAAM;QACN,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,SAAS;QACT,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA,+BAA+B;AAC/B;IACI;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,sBAAsB;AACtB;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,cAAc;AACd;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,sEAAsE;AAC1E;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":["/* Modal Overlay */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n/* Modal Container */\n.modal {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);\n    display: flex;\n    flex-direction: column;\n    max-height: 90vh;\n    width: 100%;\n    position: relative;\n    animation: modalFadeIn 0.2s ease-out;\n}\n\n/* Modal Animation */\n@keyframes modalFadeIn {\n    from {\n        opacity: 0;\n        transform: scale(0.95) translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1) translateY(0);\n    }\n}\n\n/* Modal Sizes */\n.modal--small {\n    max-width: 400px;\n}\n\n.modal--medium {\n    max-width: 600px;\n}\n\n.modal--large {\n    max-width: 800px;\n}\n\n.modal--fullscreen {\n    max-width: 100%;\n    max-height: 100%;\n    height: 100%;\n    border-radius: 0;\n    margin: 0;\n}\n\n/* Modal Header */\n.modal__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 24px;\n    border-bottom: 1px solid #eee;\n    flex-shrink: 0;\n}\n\n.modal__title, div.page section h2.modal__title {\n    margin: 0;\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #1f2937;\n    line-height: 1.5;\n    border: none;\n    padding: 0;\n}\n\n.modal__close-button {\n    background: none;\n    border: none;\n    font-size: 24px;\n    line-height: 1;\n    cursor: pointer;\n    color: #6b7280;\n    padding: 4px;\n    margin: -4px;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: color 0.15s ease, background-color 0.15s ease;\n}\n\n.modal__close-button:hover {\n    color: #374151;\n    background-color: #f3f4f6;\n}\n\n.modal__close-button:focus {\n    outline: 2px solid #3b82f6;\n    outline-offset: 2px;\n}\n\n/* Modal Content */\n.modal__content {\n    padding: 24px;\n    overflow-y: auto;\n    flex: 1;\n    min-height: 0; /* Allow content to shrink */\n}\n\n/* Modal Footer */\n.modal__footer {\n    padding: 16px 24px;\n    border-top: 1px solid #eee;\n    background-color: #f9fafb;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    flex-shrink: 0;\n}\n\n/* Mobile Styles */\n@media (max-width: 768px) {\n    .modal-overlay {\n        padding: 10px;\n        align-items: flex-end;\n    }\n\n    .modal {\n        max-height: 95vh;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n        animation: modalSlideUp 0.3s ease-out;\n    }\n\n    @keyframes modalSlideUp {\n        from {\n            opacity: 0;\n            transform: translateY(100%);\n        }\n        to {\n            opacity: 1;\n            transform: translateY(0);\n        }\n    }\n\n    .modal--fullscreen {\n        height: 100vh;\n        max-height: 100vh;\n        border-radius: 0;\n    }\n\n    .modal__header {\n        padding: 16px 20px;\n    }\n\n    .modal__title {\n        font-size: 1.125rem;\n    }\n\n    .modal__content {\n        padding: 20px;\n    }\n\n    .modal__footer {\n        padding: 16px 20px;\n    }\n\n    /* Make all modals nearly fullscreen on small devices */\n    .modal--small,\n    .modal--medium,\n    .modal--large {\n        max-width: 100%;\n        width: 100%;\n    }\n}\n\n/* Extra small mobile devices */\n@media (max-width: 480px) {\n    .modal-overlay {\n        padding: 0;\n    }\n\n    .modal {\n        height: 100vh;\n        max-height: 100vh;\n        border-radius: 0;\n        animation: modalSlideUp 0.3s ease-out;\n    }\n\n    .modal__header {\n        padding: 12px 16px;\n        position: sticky;\n        top: 0;\n        background: white;\n        z-index: 1;\n    }\n\n    .modal__content {\n        padding: 16px;\n    }\n\n    .modal__footer {\n        padding: 12px 16px;\n        position: sticky;\n        bottom: 0;\n        background: #f9fafb;\n        z-index: 1;\n    }\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n    .modal {\n        border: 2px solid #000;\n    }\n\n    .modal__header,\n    .modal__footer {\n        border-color: #000;\n    }\n\n    .modal__close-button:hover {\n        background-color: #000;\n        color: #fff;\n    }\n}\n\n/* Reduced motion support */\n@media (prefers-reduced-motion: reduce) {\n    .modal {\n        animation: none;\n    }\n\n    .modal__close-button {\n        transition: none;\n    }\n}\n\n/* Focus trap styles */\n.modal *:focus {\n    outline: 2px solid #3b82f6;\n    outline-offset: 2px;\n}\n\n/* Scrollbar styling for modal content */\n.modal__content::-webkit-scrollbar {\n    width: 8px;\n}\n\n.modal__content::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n}\n\n.modal__content::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n}\n\n.modal__content::-webkit-scrollbar-thumb:hover {\n    background: #a8a8a8;\n}\n\n/* Dark mode */\n[data-theme=\"dark\"] .modal-overlay {\n    background: rgba(0, 0, 0, 0.7);\n}\n\n[data-theme=\"dark\"] .modal {\n    background: #1c2620;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.4), 0 1px 3px rgba(0, 0, 0, 0.3);\n}\n\n[data-theme=\"dark\"] .modal__header {\n    border-bottom-color: #2c3a33;\n}\n\n[data-theme=\"dark\"] .modal__title,\n[data-theme=\"dark\"] div.page section h2.modal__title {\n    color: #e3ece6;\n}\n\n[data-theme=\"dark\"] .modal__close-button {\n    color: #9fb0a6;\n}\n\n[data-theme=\"dark\"] .modal__close-button:hover {\n    color: #e3ece6;\n    background-color: #222f28;\n}\n\n[data-theme=\"dark\"] .modal__footer {\n    border-top-color: #2c3a33;\n    background-color: #222f28;\n}\n\n[data-theme=\"dark\"] .modal__content::-webkit-scrollbar-track {\n    background: #1c2620;\n}\n\n[data-theme=\"dark\"] .modal__content::-webkit-scrollbar-thumb {\n    background: #3a463e;\n}\n\n[data-theme=\"dark\"] .modal__content::-webkit-scrollbar-thumb:hover {\n    background: #4a5850;\n}\n\n@media (max-width: 480px) {\n    [data-theme=\"dark\"] .modal__header {\n        background: #1c2620;\n    }\n\n    [data-theme=\"dark\"] .modal__footer {\n        background: #222f28;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
